import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

const criteriaParams = {
  filters: [
    'id',
    'key',
    'date',
    'status',
    'driverAssignments.id',
    'driverAssignments.driver.id',
    'driverAssignments.driver.key',
    'driverAssignments.driver.name',
    'driverAssignments.driver.driverType',
    'helperAssignments.id',
    'helperAssignments.helper.id',
    'helperAssignments.helper.key',
    'helperAssignments.helper.name',
    'equipmentAssignments.id',
    'equipmentAssignments.principal',
    'equipmentAssignments.equipment.id',
    'equipmentAssignments.equipment.key',
    'equipmentAssignments.equipment.equipmentType.size1',
    'equipmentAssignments.equipment.equipmentType.size2',
    'equipmentAssignments.equipment.equipmentType.size3',
    'equipmentAssignments.equipment.equipmentType.description',
    'tagAssignments.tag.id',
    'tagAssignments.tag.description'
  ],
  firstResult: 0,
  maxResults: 51
};

async function getRoute(id) {
  if (!id) return {};

  const criteria = JSON.stringify(criteriaParams);

  const payload = {
    criteriaChain: [
      {
        and: [
          {
            attr: 'id',
            eq: id
          }
        ]
      }
    ]
  };

  const url = `/Route/restrictions?criteria=${encodeURI(criteria)}`;

  const response = await defaultFetch(url, payload, 'POST');

  if (response.error) {
    throw new Error('Failed fetch');
  }

  return response[0];
}

export const getQueryKey = (id) => ['routeAssignments', id];

export function useRouteAssignments(id) {
  return useQuery({
    queryKey: getQueryKey(id),
    staleTime: 1000 * 60, // 1 minute
    queryFn: async () => getRoute(id)
  });
}
